import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { Users, Plus, Trash2 } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { usePermissions } from "@/lib/hooks/usePermissions"

export const users = {
  title: "Users",
  description: "Manage your organization's users.",
  route: "/settings/users",
  url: "/settings/users",
  icon: Users,
  component,
  group: "settings",
  resource: "users",
  action: "read",
} satisfies PageConfig

const columns: Columns<View<"users_with_teams">> = {
  first_name: { header: "First Name", size: 200 },
  last_name: { header: "Last Name", size: 200 },
  email: { header: "Email", size: 220 },
  status: { header: "Status", size: 120 },
  role: { header: "Role", size: 120, cell: ({ row }) => row.original.role_name },
  team_names: { 
    header: "Teams", 
    size: 200, 
    cell: ({ row }) => {
      const teamNames = row.original.team_names
      if (!teamNames || teamNames === '') return "No teams"
      return teamNames
    }
  },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const navigate = useNavigate()
  const { canCreate, canDelete } = usePermissions()

  const menu: DropdownMenuContents = [
    ...(canDelete("users") ? [{
      title: "Delete", action: async (v) => {
        await supabase.from("users").delete().eq("id", v.id)
      },
      icon: <Trash2 />,
      ask: "Are you sure you want to delete this user?",
    }] : []),
  ]


  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("users") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/settings/users/new')}><Plus className="h-4 w-4" />New User</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="users_with_teams"
        columns={columns}
        showSelection
        onRowClick={"/settings/users"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        enableServerSideFiltering={true}
        searchableColumns={["first_name", "last_name", "email"]}
      />
    </div>
  </Page>

}
